import Vue from 'vue'
import getImg from './getImg' // 获取图片路径指令
import inputInterception from './inputInterception'
for (const key in inputInterception) {
  Vue.filter(key, inputInterception[key])
}
export default {
  getImg
}
